<template>
    <svg-loader :name="'icon-help'"
              :width="20"
              :color-class="'ut-text-neutral-400'"
              class="ut-cursor-pointer ut-inline-block ut-ml-1 ut-opacity-25"
              v-tooltip="{content: tooltipContent,
          classes: ['info'], trigger: 'hover click'}" />
</template>

<script>
import SvgLoader from '@oa-vue/svg-loader/SvgLoader.vue';

export default {
  name: 'TooltipInfoCircle',
  components: {
    SvgLoader,
  },
  props: {
    tooltipContent: {
      type: String,
      required: true,
    },
  },
};
</script>
<style scoped>
</style>
